import { schema, types } from 'papr'
import { PROVIDERS } from '../shared/providers'

export const signupProfileSchema = schema({
	name: types.string({ required: true }),
	provider: types.enum(PROVIDERS, { required: true }),
	email: types.string({ required: true }),
	photo: types.string(),
	accessToken: types.string(),
	refreshToken: types.string(),
	workOSUserId: types.string(),
})

export type SignupProfileDocument = (typeof signupProfileSchema)[0]
export type SignupProfileSchemaOptions = (typeof signupProfileSchema)[1]
